import { ConfigProvider } from "antd";
import i18n from "i18next";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import useNotificationWebSocket from "./components/Notification/useNotificationWebSocket";
import { antdTheme } from "./themes/antdTheme";

import { useSelector } from "react-redux";
import CustomLoading from "./components/SplashScreen";
import DownloadProgressPanel from "./components/VMRS/ExploreArchive/DownloadProgressPanel";
import { bottomMenu, topMenu } from "./components/VMRS/ExploreArchive/MockData";
import { ESttausCode } from "./enums";
import { loadStaticConfigs } from "./helpers/common";
import RouterPage from "./router/RouterPage";
import
{
  getCommonSystemAsync,
  setAllProviders,
  setCommonSystem,
  setDataStatusOrder,
  setTheme
} from "./store/reducers/appCommonSlice";
import { getImgsAsync, setArrIdImage } from "./store/reducers/cartSlice";
import
{
  clearAllDownloads,
} from "./store/reducers/downloadSlice";
import
{
  getSideBottomMenuAsync,
  getSideMenuAsync,
  setSideBottomMenuConfig,
  setSideMenuConfig,
} from "./store/reducers/layoutSlice";
import
{
  getProviderAsync
} from "./store/reducers/mapTaskingSlice";
import { getStatusOrderAsync } from "./store/reducers/orderSlice";
import { RootState } from "./store/store";
import { ThemeProvider } from "./themes/ThemeProvider";
import { downloadManager } from "./utils/downloadManager";

export default function App()
{
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loadingGlobal, setLoadingGlobal] = useState(true);
  const downloadingFiles = useSelector(
    (state: RootState) => state.download.downloadingFiles
  );

  const handlePause = (id: string) =>
  {
    downloadManager.pause(id);
  };

  const handleResume = (id: string) =>
  {
    downloadManager.resume(id);
  };

  // WebSocket connection for real-time notifications (connects automatically on app load)
  useNotificationWebSocket();

  const getCart = async () =>
  {
    // @ts-ignore
    const res = await dispatch(getImgsAsync({})).unwrap();

    if (res?.status === ESttausCode.OK)
    {


      dispatch(
        setArrIdImage(
          res?.data?.data?.items?.map(
            (itemM: any) =>
              itemM?.stac_item_id
          ),
        ),
      );
    }
  };

  const getStatus = async () =>
  {

    // @ts-ignore
    const resProvider = await dispatch(getProviderAsync()).unwrap();

    dispatch(
      setAllProviders(
        resProvider?.data?.data?.filter((item: any) => item?.is_active) ?? [],
      ),
    );


    // @ts-ignore
    const resStatus = await dispatch(
      // @ts-ignore
      getStatusOrderAsync(),
    ).unwrap();

    dispatch(setDataStatusOrder(resStatus?.data?.data ?? []));
  };

  const getBaseMap = async () =>
  {
    console.log('getBasemap');
    // const res = await basemapService.GetbaseMap();
    // const visibleBasemaps = res?.data?.data?.configs?.filter(
    //   (item?: any) => item?.visibility,
    // );

    // if (localStorage.getItem("basemapSelected"))
    // {
    //   dispatch(
    //     setBasemapSelected(
    //       JSON.parse(localStorage.getItem("basemapSelected") ?? ""),
    //     ),
    //   );
    // } else
    // {
    //   dispatch(setBasemapSelected(visibleBasemaps?.[0]));
    //   localStorage.setItem(
    //     "basemapSelected",
    //     JSON.stringify(visibleBasemaps?.[0]),
    //   );
    // }
  };

  const getSideMenu = async () =>
  {
    // @ts-ignore
    const res = await dispatch(getSideMenuAsync()).unwrap();


    dispatch(setSideMenuConfig(res ?? topMenu));
  };

  const getSideBottomMenu = async () =>
  {
    // @ts-ignore
    const res = await dispatch(getSideBottomMenuAsync()).unwrap();
    dispatch(setSideBottomMenuConfig(res ?? bottomMenu));
  };

  const getCommonSystem = async () =>
  {
    // @ts-ignore
    const resTheme = await dispatch(getCommonSystemAsync()).unwrap();

    // dispatch(setTheme(resTheme?.data?.theme_setting?.theme));
    dispatch(setTheme('dark'))

    dispatch(setCommonSystem(resTheme?.data));
  };

  const loadGlobalData = async () =>
  {
    try
    {

      await Promise.all([
        getCommonSystem(),
        getSideMenu(),
        getSideBottomMenu(),
        getStatus(),
        getBaseMap(),
        getCart(),
      ]);

      if (!window.localStorage.getItem("language"))
      {
        window.localStorage.setItem("language", "vi");
      }
      if (!window.localStorage.getItem("viewMap"))
      {
        window.localStorage.setItem("viewMap", "basic");
      }

      i18n.changeLanguage(window.localStorage.getItem("language") ?? "vi");
    } catch (e)
    {
      console.error(e);
    } finally
    {
      // setLoadingGlobal(false);
    }
  };

  const checkAuth = async () =>
  {
    const jsonObject = await loadStaticConfigs({ dispatch });
    const token = localStorage.getItem("token");

    if (jsonObject?.REACT_APP_AUTHENTICATION_METHOD === "OAUTH2")
    {
      if (!token)
      {
        if (window.location.pathname !== "/login")
        {
          navigate("/login", { replace: true });
        }
        setLoadingGlobal(false);
        return;
      }

      if (window.location.pathname === "/login")
      {
        if (token && localStorage.getItem("token_type"))
        {
          navigate("/", { replace: true });
        }

        setLoadingGlobal(false);
        return;
      }
    } else if (jsonObject?.REACT_APP_AUTHENTICATION_METHOD === "COOKIES")
    {
      if (localStorage.getItem("token"))
      {
        localStorage.removeItem("token");
      }
      if (localStorage.getItem("token_type"))
      {
        localStorage.removeItem("token_type");
      }
    }

    await loadGlobalData();
    setLoadingGlobal(false);
  };

  useEffect(() =>
  {
    checkAuth();
  }, []);

  return (
    <>
      <ThemeProvider />
      <ConfigProvider theme={antdTheme} form={{ requiredMark: false }}>
        {/* <CustomLoading /> */}
        {loadingGlobal && <CustomLoading />}

        <ToastContainer
          position="bottom-center"
          autoClose={3000}
          theme="dark"
          pauseOnHover={true}
        />
        {!loadingGlobal && <RouterPage />}

        {/* Global Download Progress Panel */}
        <DownloadProgressPanel
          files={downloadingFiles}
          onCancel={() => dispatch(clearAllDownloads())}
          onPause={handlePause}
          onResume={handleResume}
        />
      </ConfigProvider>
    </>
  );
}
